import { channelType, externalType, vodPagePath } from '@/shared/constants'
import { useVisibilityStore } from '@/shared/store'
import { RawLink } from '@/shared/ui'
import { Box } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom'
import { seriesPagePath } from '@/shared/constants/seriesConstants'

interface Props {
    isHomeContentItem?: boolean
    assetType?: string
    productId?: string | null
    children: JSX.Element
}
const VodItemWrapper: React.FC<Props> = ({
    assetType,
    isHomeContentItem,
    children,
}) => {
    const { setSeriesContentVisible } = useVisibilityStore()
    const { pathname } = useLocation()
    const path = pathname === seriesPagePath ? seriesPagePath : vodPagePath
    const isVodType = assetType !== externalType && assetType !== channelType

    const shouldLinkToVodPage = isHomeContentItem && isVodType

    const handleItemClick = () => {
        if (shouldLinkToVodPage) {
            if (path === seriesPagePath) {
                setSeriesContentVisible()
            } else if (path === vodPagePath) {
                // setVodContentVisible()
            }
        }
    }

    return (
        <Box position="relative" onClick={handleItemClick}>
            {shouldLinkToVodPage ? (
                <RawLink to={path}>{children}</RawLink>
            ) : (
                children
            )}
        </Box>
    )
}
export default VodItemWrapper
